<style>

.tableDesign .el-input__inner{
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <Reward ref="RewardRef" :single="true" />
      <el-tabs active-name="1" tab-position="left" style="background-color: #ffffff;height: 800px" @tab-click="handleTabClick">
        <el-row :gutter="10">
          <CommonExcel ref="CommonExcelRef2" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importCfg" :export-method="exportCfg" />
          <clear-cache-apply />
        </el-row>
        <el-tab-pane v-for="(item,type) in typeArr" :key="type" :name="type" :label="item">
          <el-card class="box-card">
            <el-table class="tableDesign" size="mini" :data="list[type]" border style="width: 50%" height="600">
              <el-table-column label="序号" align="center" width="100">
                <template v-slot:default="{row,$index}">
                  <span style="display:block;" :title="row.id">{{ $index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称" align="center">
                <template v-slot:default="{row}">
                  <el-input v-model="row.name" style="width: 250px;" placeholder="名称" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template v-slot:default="{row,$index}">
                  <el-button type="primary" size="mini" @click="openDialog(row.config)">查看</el-button>
                  <el-button type="danger" size="mini" @click="handleDel($index,row.id)">删除</el-button>
                  <el-button type="success" size="mini" @click="handleCopy(row)">拷贝</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="handleAdd(type,'新增配置',[])">新增</el-button>
              <el-button v-prevent-re-click type="primary" size="mini" style="margin:10px 10px" @click="handleSaveConfig()">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
      <el-dialog :show-close="false" title="提示" :before-close="handleClose" :visible.sync="dialog" width="60%">
        <el-table :key="tableKey" size="mini" :data="diaLogList" border fit highlight-current-row style="width: 100%;" height="500">
          <template v-if="type==1">
            <el-table-column prop="levelId" label="等级ID">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.levelId" placeholder="任务值" />
              </template>
            </el-table-column>
            <el-table-column prop="speed" label="速度">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.speed" placeholder="速度" />
              </template>
            </el-table-column>
            <el-table-column prop="background" label="背景">
              <template v-slot:default="scope">
                <el-button type="text" style="margin-left: 16px;color: #606266" @click="handleBackground(scope.row.background,scope.$index)"><i class="el-icon-edit-outline" />{{ showBackground(scope.row.background) }}</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="prize" label="奖励">
              <template v-slot:default="scope">
                <el-button type="text" style="margin-left: 16px;color: #606266" @click="handleConf(scope.row.conf,scope.$index)"><i class="el-icon-edit-outline" />{{ showReward(scope.row.conf) }}</el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template v-slot:default="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <span slot="footer" class="dialog-footer" style="margin-right: 10px"><el-button size="small" type="primary" @click="addRewardDialogList">新增</el-button></span>
        <span slot="footer" class="dialog-footer"><el-button size="small" @click="dialog = false">关 闭</el-button></span>
      </el-dialog>

      <el-drawer title="奖励配置" :visible.sync="dialog2" size="800px" @close="handleReward">
        <el-form :inline="true">
          <el-row v-for="(conf,i) in reward" :key="i">
            <el-form-item label="时间(s)">
              <el-input v-model.number="conf.time" style="width: 100px;" placeholder="时间(s)" />
            </el-form-item>
            <el-form-item label="数量">
              <el-input v-model.number="conf.num" style="width: 100px;" placeholder="数量" />
            </el-form-item>
            <el-form-item label="金币">
              <el-input v-model.number="conf.money" style="width: 100px;" placeholder="金币" />
            </el-form-item>
            <el-form-item label="权重">
              <el-input v-model.number="conf.v" style="width: 100px;" placeholder="权重" />
            </el-form-item>
            <el-form-item>
              <el-button type="danger" @click="delReward(i)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-button style="margin-top: 10px;" type="primary" @click="addReward(i)">+</el-button>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialog2 = false">取 消</el-button>
          <el-button type="primary" @click="dialog2">确 定</el-button>
        </span>
      </el-drawer>

      <el-drawer title="奖励配置" :visible.sync="dialog3" size="800px" @close="handleBackground2">
        <el-form :inline="true">
          <el-row v-for="(conf,i) in background" :key="i">
            <el-form-item label="背景">
              <el-input v-model="conf.background" style="width: 100px;" placeholder="背景" />
            </el-form-item>
            <el-form-item label="权重">
              <el-input v-model.number="conf.v" style="width: 100px;" placeholder="权重" />
            </el-form-item>
            <el-form-item>
              <el-button type="danger" @click="delBackground(i)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-button style="margin-top: 10px;" type="primary" @click="addBackground()">+</el-button>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialog3 = false">取 消</el-button>
          <el-button type="primary" @click="dialog3">确 定</el-button>
        </span>
      </el-drawer>

    </template>
  </BasicLayout>
</template>

<script>

import CommonExcel from '@/components/CommonExcel'
import Reward from '@/components/Reward'
import { downloadExcelMultiSheet } from '@/utils/excel'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { actAuxiliary, actionActAuxiliary, delActAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import { getBetConfig } from '@/api/config/common-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'

export default {
  name: 'CoinSLot',
  components: { ClearCacheApply, CommonExcel, Reward },
  data() {
    return {
      tableKey: 0,
      limitType: [2],
      loading: false,
      dialog: false,
      dialog2: false,
      dialog3: false,
      dialogIndex: -1,
      diaLogList: [],
      total: 0,
      list: [],
      type: 1,
      typeArr: { 1: '奖励配置' },
      baseList: [],
      mapDialog: false,
      mapDialogList: [],
      groupsList: [],
      skuList: [],
      curClass: 'airship',
      betArr: [],
      reward: [],
      background: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getBetCfg()
      this.getList()
      this.initBase()
    },
    initBase() {
      getUserTypeAllList().then(res => {
        res.data.forEach(res => {
          this.groupsList.push({ name: res.name, id: res.groupId })
        })
      })
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    openDialog(config) {
      this.tableKey++
      this.diaLogList = config
      this.dialog = true
    },
    handleTabClick(val) {
      this.type = Number(val.name)
      this.diaLogList = []
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
        for (let i = 0; i < this.list[1].length; i++) {
          for (let j = 0; j < this.list[1][i].config.length; j++) {
            if (!this.list[1][i].config[j].background) {
              this.list[1][i].config[j].background = []
            }
          }
        }
      })
    },
    handleDel(index, id) {
      this.$confirm('确认要删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (id !== 0) {
          delActAuxiliary({ idList: [id] })
        }
        this.list[this.type].splice(index, 1)
      })
    },
    handleCopy(row) {
      const _row = Object.assign({}, row)
      _row.id = 0
      this.list[this.type].push(_row)
    },
    handleAdd(type, name, config) {
      this.list[type].push({ id: 0, name: name, class: this.curClass, type: type, config: config })
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const sheet = excelData[i].sheetName
        let editFlag = false
        for (let j = 0; j < this.list[this.type].length; j++) {
          if (this.list[this.type][j].name === sheet) {
            this.list[this.type][j].config = excelData[i].sheetData
            editFlag = true
          }
        }
        if (!editFlag) {
          this.handleAdd(this.type, sheet, excelData[i].sheetData)
        }
      }
    },
    handleSaveConfig(type) {
      actionActAuxiliary({ class: this.curClass, list: this.list }).then(response => {
        this.msgSuccess('保存成功', () => {
          this.getList()
        }, 1000)
      })
    },
    exportCfg() {
      const nameArr = []
      const dataArr = []
      for (let i = 0; i < this.list[this.type].length; i++) {
        nameArr.push(this.list[this.type][i].name)
        dataArr.push(this.list[this.type][i].config)
      }
      this.onExport(this.type, nameArr, dataArr)
      return Promise.reject()
    },
    onExport(type, name, dataArr) {
      let fileName = ''
      const hearer = []
      const excelData = []
      fileName = this.typeArr[type]

      for (let i = 0; i < dataArr.length; i++) {
        const tAk = this.$refs.CommonExcelRef2.makeExcelData(dataArr[i], { levelId: '等级', speed: '速度', background: { name: '背景', sub: { background: '背景', v: '权重' }}, conf: { name: '奖励', sub: { time: '时间', money: '金币', num: '数量', v: '权重' }}})
        hearer.push(tAk[0])
        excelData.push(tAk[1])
      }

      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    addBaseConfig() {
      this.baseList.push({ minLv: 1, maxLv: 999, groupIds: [], rewardId: 0 })
    },
    deleteBaseConfig(index) {
      this.baseList.splice(index, 1)
    },
    addRewardDialogList(index) {
      this.diaLogList.push({
        levelId: 0,
        speed: 0,
        background: [],
        conf: []
      })
    },
    deleteRewardDialogList(index) {
      this.diaLogList.splice(index, 1)
    },
    handleChangePrice(row) {
      for (let i = 0; i < this.skuList.length; i++) {
        if (row.price === this.skuList[i].price) {
          row.sku = this.skuList[i].sku
          break
        }
      }
    },
    getBetCfg() {
      getBetConfig().then(res => {
        this.betArr = []
        res.data.forEach(item => {
          if (item <= 3) {
            this.betArr.push({ label: '下注' + item, value: item })
          }
        })
      })
    },
    handleConf(conf, index) {
      if (!conf) {
        conf = []
      }
      this.dialog2 = true
      this.reward = conf
      this.dialogIndex = index
    },
    handleBackground(conf, index) {
      if (!conf) {
        conf = []
      }
      this.dialog3 = true
      this.background = conf
      this.dialogIndex = index
    },
    addReward() {
      this.reward.push({ time: 0, num: 0, money: 0, v: 0 })
    },
    delReward(index) {
      this.reward.splice(index, 1)
    },
    addBackground() {
      this.background.push({ background: 1, v: 0 })
    },
    delBackground(index) {
      this.background.splice(index, 1)
    },
    handleReward() {
      for (const i in this.diaLogList) {
        if (i === this.dialogIndex) {
          this.diaLogList[i].conf = this.reward
        }
      }
    },
    handleBackground2() {
      for (const i in this.diaLogList) {
        if (i === this.dialogIndex) {
          this.diaLogList[i].background = this.background
        }
      }
    },
    showReward(conf) {
      const reward = []
      conf.forEach(item => {
        reward.push(`数量:${item.num},时间:${item.time},金币:${item.money},权重:${item.v}`)
      })
      return reward.join(',')
    },
    showBackground(conf) {
      if (!conf) {
        conf = []
      }
      const reward = []
      conf.forEach(item => {
        reward.push(`背景:${item.background},权重:${item.v}`)
      })
      return reward.join(',')
    }
  }
}
</script>

